* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    --primary-audio-colour: #ff9800;
    --primary-audio-colour-50: rgba(255, 152, 0, 0.5);
    --primary-audio-colour-10: rgba(255, 152, 0, 0.1);
}


:host {
    background: black;
    font-family: "Segoe UI", Arial;
    display: flex;
    justify-content: center;
    color: white;
    min-height: 100vh;
    width: 100%;
}

/* mobile frame */

.overlay {
    width: min(100%, 768px);
    flex-shrink: 0;
    max-width: 100vw;
    min-height: 100vh;
    padding: 40px 20px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    /* Forces children to take up the full width */
    justify-content: flex-end;
    position: relative;
    box-sizing: border-box;

    /* Background fix */
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
}


#nav-bar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    z-index: 10;
}

.nav {
    background: rgba(0, 0, 0, 0.6);
    /* Darker for better contrast on images */
    backdrop-filter: blur(5px);
    /* Modern frosted-glass effect */
    -webkit-backdrop-filter: blur(5px);
    padding: 10px 16px;
    border-radius: 20px;
    color: white;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.nav:active {
    background: rgba(255, 255, 255, 0.3);
}

#nav-bar .nav {
    pointer-events: auto;
}

.previous,
.next {
    position: absolute;
    bottom: calc(20px + env(safe-area-inset-bottom));
}

.previous {
    left: 20px;
}

.next {
    right: 20px;
    background: var(--primary-audio-colour);
    border: none;
}

.menu {
    position: absolute;
    top: 15px;
    left: 15px;
}

#download-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    z-index: 100;
    padding: 8px 12px;
    font-size: 0.8rem;
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    background: #333;
    color: white;
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 140px;
    transition: all 0.3s ease;
}

#download-btn.complete {
    border-color: #2e7d32;
    background: #2e7d32;
}

#download-btn.collapsed {
    min-width: auto;
    width: 40px;
    height: 40px;
    padding: 0;
    border-radius: 50%;
    /* color: transparent; */
    padding-left: 11px;
    overflow: hidden;
}

#download-btn.collapsed svg {
    fill: white;
    color: white;
    width: 20px;
    height: 20px;
}

#download-btn.collapsed.expanded {
    min-width: 140px;
    width:fit-content;
    border-radius: 20px;
    color: white;
    padding: 8px 12px;
}

.menu-stop-btn.download-main:disabled {
    opacity: 0.8;
    cursor: wait;
}

/* title */

h1 {
    font-size: 26px;
    text-align: center;
    margin-bottom: 20px;
}

/* description */

.text {
    width: 100%;
    background: rgba(255, 255, 255, 0.15);
    padding: 20px;
    border-radius: 15px;
    text-align: center;
    line-height: 1.6;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(5px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.fade-in {
    animation: fadeIn 0.5s ease-out forwards;
}

#title.fade-in {
    animation-delay: 0s;
}

#desc.fade-in {
    animation-delay: 0.2s;
    opacity: 0;
}


/* buttons */

.buttons {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
}

/* listen */

.listen,
.restart {
    background: var(--primary-audio-colour);
    border: none;
    padding: 14px 30px;
    border-radius: 30px;
    color: white;
    font-size: 16px;
    cursor: pointer;
}

.audio-controls {
    display: inline-flex;
    align-items: center;
    border: 2px solid var(--primary-audio-colour);
    border-radius: 30px;
    overflow: hidden;
    background-color: var(--primary-audio-colour);
    /* Prevent text selection on long-press */
    -webkit-user-select: none;
    user-select: none;
}

.audio-controls-group button {
    background: var(--primary-audio-colour);
    border: none;
    padding: 18px 22px;
    cursor: pointer;
    font-size: 1.4rem;
    -webkit-tap-highlight-color: transparent;
}

.audio-controls button:active svg {
    transform: scale(0.9);
    transition: transform 0.1s ease;
}

.audio-controls svg {
    display: block;
    margin: auto;
}

.audio-controls button {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
    -webkit-tap-highlight-color: transparent;
}

@keyframes pulse {
    0% {
        transform: scale(1);
        opacity: 1;
    }

    50% {
        transform: scale(1.5);
        opacity: 0.7;
    }

    100% {
        transform: scale(1);
        opacity: 1;
    }
}

.playing {
    display: inline-block;
    animation: pulse 1.5s ease-in-out infinite;
    color: white;
}

#headphones {
    font-size: 1.1rem;
    padding: 0 5px;
    user-select: none;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

#headphones.buffering svg {
    animation: spin 1s linear infinite;
    opacity: 0.6;
}

#progressBar {
    -webkit-appearance: none;
    appearance: none;
    width: 80%;
    height: 8px;
    border-radius: 5px;
    outline: none;
    margin-bottom: 15px;
    cursor: pointer;
    background: linear-gradient(to right, var(--primary-audio-colour) 0%, rgba(255, 255, 255, 0.3) 0%);
}

#progressBar::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    background: var(--primary-audio-colour);
    border-radius: 50%;
    cursor: pointer;
    border: 2px solid white;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}

#progressBar::-moz-range-thumb {
    width: 20px;
    height: 20px;
    background: var(--primary-audio-colour);
    border-radius: 50%;
    cursor: pointer;
    border: 2px solid white;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}

#menu-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
    margin-top: 20px;
}

.menu-stop-btn {
    width: auto;

    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: white;
    padding: 8px 16px;
    border-radius: 20px;

    font-size: 14px;
    cursor: pointer;
    backdrop-filter: blur(5px);
    transition: all 0.2s ease;
    white-space: nowrap;
}

.menu-stop-btn:active {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(0.95);
}

.gallery-btn {
    color: white;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);
    padding: 2px 16px;

}

/* Swipe Feedback Indicators */
.swipe-hint {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 60px;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.2s ease;
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    color: var(--primary-audio-colour-50);
}

.hint-left {
    left: 0;
    background: linear-gradient(to right, var(--primary-audio-colour-10), transparent);
}

.hint-right {
    right: 0;
    background: linear-gradient(to left, var(--primary-audio-colour-10), transparent);
}

.hint-visible {
    opacity: 1;
}

/* --- Photo Gallery Overlay Infrastructure --- */

.gallery-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.94);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 500;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.25s ease-in-out;
}

.gallery-overlay.active {
    opacity: 1;
    pointer-events: auto;
}

.gallery-close { 
    position: absolute;
    top: 15px;
    right: 15px;
    background: rgba(0, 0, 0, 0.0);
    border: 1px solid rgba(255, 255, 255, 0.0);
    color: white;
    font-size: 28px;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    /* align-items: center; */
    justify-content: center;
    z-index: 520;
    line-height: 1;
    transition: background-color 0.2s;
}

.gallery-close:active {
    background: rgba(255, 255, 255, 0.3);
}

.gallery-viewport {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
    touch-action: none;
    width: 100%;
}

.gallery-img {
    max-width: 100%;
    max-height: 75vh;
    object-fit: contain;
    user-select: none;
    -webkit-user-drag: none;
    transform-origin: center center;
    transition: transform 0.08s ease-out;
}

.gallery-caption {
    color: white;
    text-align: center;
    padding: 25px 25px 35px 25px;
    font-size: 15px;
    line-height: 1.5;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.85));
    width: 100%;
    z-index: 510;
}

.gallery-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: white;
    width: 46px;
    height: 46px;
    cursor: pointer;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 515;
    transition: background-color 0.2s;
}

.gallery-nav:active {
    background: rgba(255, 255, 255, 0.3);
}

.gallery-nav.prev {
    left: 15px;
}

.gallery-nav.next {
    right: 15px;
}